<template>
    <div>
        <Accordion :activeIndex="0">
            <AccordionTab header="Use as many or few filters as you wish.">
                <!-- All the criterias here -->
                <div class="p-fluid formgrid grid">
                    <div class="field col-6 md:col-3">
                        <label for="code">Attribute Code:</label>
                        <InputText maxlength = "255" id="code" v-model.trim="params.code" placeholder="Input attribute code" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="sharedCompany">Shared/Company:</label>
                        <Dropdown inputId="sharedCompany" v-model="params.shared" :options="getSharedTypes()" placeholder="Select an attribute type" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="status">Status:</label>
                        <Dropdown inputId="status" v-model="params.default" :options="getDefaultTypes()" optionLabel="name" optionValue="value" placeholder="Select attribute status" :showClear="true" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="type">Attribute Type:</label>
                        <Dropdown inputId="type" v-model="params.user_profile" :options="getUserProfileTypes()" optionLabel="name" optionValue="value" placeholder="Select attribute type" :showClear="true" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="type">Tagged Attribute: </label>
                        <Dropdown inputId="type" v-model="params.tagged" :options="getAttributeTaggedOptions()" optionLabel="name" optionValue="value" placeholder="Select an option" :showClear="true" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="category">Attribute Category: </label>
                        <Dropdown inputId="category" v-model="params.category" :options="getInputTypeCategories()" optionLabel="name" optionValue="value" placeholder="Select an option" :showClear="true" />
                    </div>

                    <div class="field col-6 md:col-3 mt-4">
                        <Button label="Reset Filters" icon="pi pi-refresh" @click="clearCriteria" />
                    </div>

                    <div class="field col-12">
                        <template v-if="params.user_profile === UserProfileTypes.USER_PROFILE || params.user_profile === UserProfileTypes.BOTH">
                            <template v-if="checkUserPermission(UserPermissions.DELETE_USER_PROFILE_ATTRIBUTES) && checkUserPermission(UserPermissions.WRITE_ASSESSMENT_BLOCKS)">
                                <div class="grid mt-2">
                                    <div class="col-1 flex justify-content-end">
                                        <i class="pi pi-question-circle flex align-items-center" style="font-size: 2rem; color: darkblue"></i>
                                    </div>
                                    <div class="col-11">
                                        <b>How to delete user profile attribute</b>:<br />
                                        as usual, an attribute used by a Block cannot be deleted. To delete it, it must be
                                        removed from the Block that use it.<br />
                                        <b>Please, open the attribute and follow the dedicated procedure that will guide you.</b>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>

                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import { watch, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAttributeStore } from '../store';
import { getInputTypeCategories, getUserProfileTypes, getAttributeTaggedOptions } from '../constants';
import { getSharedTypes, getDefaultTypes } from '../../../constants';
import { UserProfileTypes } from '@/products/pha/modules/attribute/enum';
import { UserPermissions } from '@/enums';
import useUserComposable from '@/composables/UserComposable';

const attributeStore = useAttributeStore();
const { params } = storeToRefs(attributeStore);

const { checkUserPermission } = useUserComposable();

watch(params.value, () => {
    loadAttributes();
});

const loadAttributes = async () => {
    await attributeStore.fetchAllAttributes(true);
};

const clearCriteria = async () => {
    attributeStore.clearFilters();
};

onUnmounted(() => {
    clearCriteria();
});
</script>
